"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('widgets/shared/identity/login/login',["require", "exports", "text!./login.html", "knockout", "services/authenticationService", "scriptLoaders/bundleLoader", "models/userIdentityModel", "store/tokenStore", "helpers/accessTokenHelper", "context"], function (require, exports, templateMarkup, ko, authenticationService, bundleLoader, userIdentityModel, tokenStore, accessTokenHelper, context) {
    "use strict";
    /// <amd-dependency path='text!./login.html' name='templateMarkup' />

    var Login = function () {
        function Login() {
            _classCallCheck(this, Login);

            this.checkingCredentials = ko.observable(false);
            this.gettingClaims = ko.observable(false);
            this.message = ko.observable('');
            this.messageVisible = ko.observable(false);
            this.username = ko.observable('');
            this.password = ko.observable('');
            this.rememberMe = ko.observable(true);
            this.usernameMissing = ko.observable(false);
            this.passwordMissing = ko.observable(false);
            this.errorMessageTimeout = null;
            this.username.subscribe(this.usernameMissing.bind(this, false));
            this.password.subscribe(this.passwordMissing.bind(this, false));
        }

        _createClass(Login, [{
            key: "login",
            value: function login() {
                var _this = this;

                if (this.username() && this.password()) {
                    this.checkingCredentials(true);
                    authenticationService.login(this.username(), this.password(), this.rememberMe()).fail(function (loginResponse) {
                        _this.checkingCredentials(false);
                        _this.gettingClaims(false);
                        _this.showErrorMessage(loginResponse.responseText);
                    }).done(function (loginResponse) {
                        if (loginResponse !== null) {
                            userIdentityModel.clear();
                            tokenStore.setPersistence(_this.rememberMe());
                            if (loginResponse.token) {
                                _this.gettingClaims(true);
                                tokenStore.setAccessToken(loginResponse.token.accessToken, loginResponse.token.refreshToken, loginResponse.token.accessTokenExpiresIn);
                                accessTokenHelper.setRefreshTimeout();
                                authenticationService.getManageInfo().done(function (manageInfoResponse) {
                                    context.hereMapsApiKey = manageInfoResponse.hereMapsApiKey;
                                    context.appBundleUrl = manageInfoResponse.appBundleUrl;
                                    bundleLoader.loadBundleAsyncOnce().done(function () {
                                        require(['app/startup'], function () {
                                            userIdentityModel.setSessionId(manageInfoResponse.sessionId);
                                            userIdentityModel.claims(manageInfoResponse.claims);
                                            userIdentityModel.setUserName(manageInfoResponse.email);
                                            userIdentityModel.setLocalLoginProvider(manageInfoResponse.localLoginProvider);
                                            userIdentityModel.setInsurerId();
                                            userIdentityModel.isAuthenticated(true);
                                            _this.checkingCredentials(false);
                                            _this.gettingClaims(false);
                                        });
                                    });
                                }).fail(function (err) {
                                    userIdentityModel.isAuthenticated(false);
                                    _this.checkingCredentials(false);
                                    _this.gettingClaims(false);
                                });
                            } else {
                                userIdentityModel.requiresTwoFactor(true);
                                userIdentityModel.setUserName(_this.username());
                                userIdentityModel.qrCodeSetupImageUrl(loginResponse.qrCodeSetupImageUrl);
                                userIdentityModel.manualEntryKey(loginResponse.manualEntryKey);
                            }
                        }
                    });
                } else {
                    this.usernameMissing(this.username() === '');
                    this.passwordMissing(this.password() === '');
                    this.showErrorMessage('Login failed');
                }
            }
        }, {
            key: "showErrorMessage",
            value: function showErrorMessage(error) {
                this.message(error);
                this.resetAnimation();
                this.messageVisible(true);
                if (this.errorMessageTimeout) {
                    clearTimeout(this.errorMessageTimeout);
                }
                this.errorMessageTimeout = setTimeout(function () {
                    this.messageVisible(false);
                }.bind(this), 6000);
            }
        }, {
            key: "resetAnimation",
            value: function resetAnimation() {
                var $loginForm = $('.login-form')[0];
                $loginForm.style.animation = 'none';
                $loginForm.focus(); /* trigger reflow */
                $loginForm.style.animation = null;
            }
        }]);

        return Login;
    }();

    return { viewModel: Login, template: templateMarkup };
});
//# sourceMappingURL=login.js.map;
